package com.neurobs.react.semanticui

import com.neurobs.react.{ReactUtil, StyleUtil}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.html._

object UiGridFactory {

  private def TemplateGrid(children: ReactElement*)(uiElementModifiers: UiElementModifiers) = {
    div(
      className := uiElementModifiers.formattedClassName("grid"),
      style := uiElementModifiers.createStyle
    )(
      children:_*
    )
  }

  private def TemplateGridColumn(children: ReactElement*)(uiElementModifiers: UiElementModifiers) = {

    div(
      className := s"${uiElementModifiers.elementModifiers} column ${uiElementModifiers.classString}",
      style := uiElementModifiers.createStyle
    )(
      children:_*
    )
  }

  def Grid(children: ReactElement*)(implicit uiElementModifiers: UiElementModifiers) = TemplateGrid(children:_*)(uiElementModifiers)

  def AlignedGrid(centered: Boolean = true, vertical: Option[String] = Some("middle"))(children: ReactElement*)(implicit uiElementModifiers: UiElementModifiers) = {
    val gridModifiers = s"${vertical.map(_ + " aligned").getOrElse("")} ${if (centered) "centered" else ""} ${uiElementModifiers.elementModifiers}"
    TemplateGrid(children)(gridModifiers, uiElementModifiers.classString, uiElementModifiers.styleAttributes)
  }

  def GridColumn(children: ReactElement*)(implicit uiElementModifiers: UiElementModifiers) = TemplateGridColumn(children:_*)(uiElementModifiers)

}


